import React, {useState} from 'react';
import {logOut, reset} from "../../Features/Auth/authSlice";
import {offCanvasReset} from "../../Features/Misc/offCanvasSlice";
import {navBarReset} from "../../Features/Misc/navBarSlice";
import {activeMediaReset, activeReset} from "../../Features/Misc/activeSlice";
import {persistor} from "../../store";
import {useDispatch} from "react-redux";
import {resetLoginStep} from "../../Features/Misc/loginSlice";

function MyAccountDropdown(props) {
    const dispatch = useDispatch()

    const [dropDownActive, toggleDropDownActive] = useState(false)

    const handleLogout = () =>{

        dispatch(reset());
        dispatch(offCanvasReset());
        dispatch(navBarReset());
        dispatch(activeReset());
        dispatch(activeMediaReset());
        dispatch(resetLoginStep());
        dispatch(logOut());
        persistor.purge();

    }

    return (
        <div
            onMouseEnter={() => toggleDropDownActive(true) }
            onMouseLeave={() => toggleDropDownActive(false)
        }
            className={`MyAccountDropDown sm:hidden flex flex-col w-full h-32 bg-pink-dashboard relative  rounded-lg text-white`}>
            <div className={`MyAccountDropDown__myAccount flex flex-row  rounded-lg h-10 items-center justify-between px-4 bg-gold-accent  `}  >

                {/*<div className={`flex flex-row gap-4`}>*/}
               {/*    <i className="ri-account-circle-line"></i>*/}
               {/*    <div>My Account</div>*/}
               {/*</div>*/}
                {/*<button*/}
                {/*    disabled*/}
                {/*    className={`MyAccountDropDown__settings hidden flex flex-row gap-4 h-10 items-center  px-4 opacity-40`}>*/}
                {/*    <i className="ri-settings-3-line"></i>*/}
                {/*    <div>Settings</div>*/}
                {/*</button>*/}

                <div className={`MyAccountDropDown__logOut  flex flex-row gap-4 h-10 items-center rounded-b-lg  px-4  cursor-pointer hover:opacity-60 transition-opacity duration-300`}>
                    <i className="ri-logout-box-line"></i>
                    <div onClick={handleLogout}>Log Out</div>
                </div>
            </div>

        </div>
    );
}

export default MyAccountDropdown;
